import { configureStore } from "@reduxjs/toolkit";
import shopReducer from "./features/shop.js";
import hostReducer from "./features/host.js";
import sseSessionReducer from "./features/sseSession.js";
import actionReducer from "./features/action.js";
import modalReducer from "./features/modal.js";
import logger from "redux-logger";

export const store = configureStore({
  reducer: {
    shop: shopReducer,
    host: hostReducer,
    sseSession: sseSessionReducer,
    action: actionReducer,
    modal: modalReducer
  },
  // @ts-ignore
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(logger)
});

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch